import React, { CSSProperties, useState } from 'react';
import { API_ORIGIN } from '@api/fetchApi';
import cn from 'classnames';
import { defaultAvatarColorsGenerator } from 'utils/defaultAvatarColorsGenerator';
import styles from './styles.module.scss';

interface IUserAvatarProps {
  avatarSource: string | null;
  userInitials: string;
  size: number;
  withBorder?: boolean;
  className?: string;
}

export const UserAvatar = (props: IUserAvatarProps) => {
  const [isAvatarLoadedWithError, setIsAvatarLoadedWithError] = useState(false);

  const { avatarSource, withBorder, size, className, userInitials } = props;

  const defaultAvatarColors = defaultAvatarColorsGenerator(userInitials);

  const textColor = defaultAvatarColors.font;
  const backgroundColor = !avatarSource ? defaultAvatarColors.background : 'inherit';

  const avatarStyles: CSSProperties = {
    color: textColor,
    background: backgroundColor,
    width: size,
    height: size,
    fontSize: Math.round(size / 2.5),
  };

  const avatarClassNames = cn(styles.avatar, withBorder && styles.avatarWithBorders, className);

  const imageSrc = avatarSource?.includes(API_ORIGIN) ? avatarSource : API_ORIGIN + avatarSource;

  return (
    <div className={avatarClassNames} style={avatarStyles}>
      {avatarSource && !isAvatarLoadedWithError ? (
        <img
          height={size}
          width={size}
          className={styles.avatarImage}
          src={imageSrc}
          alt=""
          onError={() => setIsAvatarLoadedWithError(true)}
        />
      ) : (
        <div className={styles.avatarUserInitial}>{userInitials}</div>
      )}
    </div>
  );
};
